let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iuQwY")).then(() => parcelRequire('6jzGo'));